<template>
  <page-wrapper title="รายละเอียดคูปอง" :hasPad="true">
    <sc-button class="mb-4" variant="secondary" size="sm" :route="usageRoute"
      >ประวัติการใช้งาน</sc-button
    >
    <coupon-editor v-if="form" v-model="form" :disableProjectDeleteAll="true"></coupon-editor>
    <div class="row mt-5">
      <div class="col-6">
        <sc-button variant="danger" @click="handleClickRemoveButton">ลบ</sc-button>
      </div>
      <div class="col-6">
        <sc-button
          class="btn-submit"
          variant="primary"
          @click="handleClickSubmitButton"
        >บันทึก</sc-button>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import { DateTime } from "luxon";
import { baanRueJaiClient } from "@/dependencies";
import CouponEditor from "../components/CouponEditor";
import { toOptionalISOString } from "@/lib/dateTime";

export default {
  components: {
    PageWrapper,
    CouponEditor,
    ScButton
  },
  data() {
    const coupon = null;
    const form = null;

    return {
      coupon,
      form
    };
  },
  created() {
    this.setup();
  },
  computed: {
    usageRoute() {
      const id = this.$route.params.id;

      return { name: "CouponUsagePage", params: { id } };
    }
  },
  methods: {
    setup() {
      this.setupData();
    },
    async setupData() {
      await this.setupCoupon();
      await this.setupForm();
    },
    async setupCoupon() {
      const coupon = await this.fetchCoupon();

      this.coupon = coupon;
    },
    async setupForm() {
      const {
        code,
        effective_date,
        expiry_date,
        usage_quota: usageQuota,
        usage_quota_per_user: usageQuotaPerUser,
        minimum_purchased_amount: minimumPurchasedAmount,
        maximum_discount_amount: maximumDiscountAmount,
        selected_packages: selectedPackages,
        discount_amount: discountAmount,
        discount_percent_amount: discountPercentAmount,
        supported_project_ids: supportedProjectIds,
        expired_days_after_transfered: expiredDaysAfterTransfered,
        is_first_time_only: isFirstTimeOnly,
        is_expired: isExpired,
        excluded_packages
      } = this.coupon;

      const effectiveDate = DateTime.fromISO(effective_date);
      const expiryDate = DateTime.fromISO(expiry_date);

      const excludedPackages = excluded_packages
        && excluded_packages.packages
        && excluded_packages.packages.length > 0
        ? excluded_packages.packages.map(item => {
        const {
          id,
          name,
          price,
          billing_cycle: billingCycle,
          detail,
          service_ids,
          project_ids,
          image: imageUrl,
          target,
        } = item;

        return {
          id: id.toString(),
          name: name,
          target,
          price,
          billingCycle,
          detail,
          serviceCount: service_ids.length,
          projectCount: (project_ids || []).length,
          imageUrl,
          hasSelected: false
        };
      })
      : null

      this.form = {
        code,
        effectiveDate,
        expiryDate,
        expiredDaysAfterTransfered,
        usageQuota,
        usageQuotaPerUser,
        minimumPurchasedAmount,
        maximumDiscountAmount,
        selectedPackages: selectedPackages.packages.map(item => {
          const {
            id,
            name,
            price,
            billing_cycle: billingCycle,
            detail,
            service_ids,
            project_ids,
            image: imageUrl,
            target,
          } = item;

          return {
            id: id.toString(),
            name: name,
            target,
            price,
            billingCycle,
            detail,
            serviceCount: service_ids.length,
            projectCount: (project_ids || []).length,
            imageUrl,
            hasSelected: true
          };
        }),
        discountAmount,
        discountPercentAmount,
        supportedProjectIds,
        isFirstTimeOnly,
        isActionEdit: true,
        isExpired,
        excludedPackages
      };
    },
    async fetchCoupon() {
      const { id } = this.$route.params;
      const response = await baanRueJaiClient.admin.subscriptions.coupons.get(
        id
      );

      return response.data.result;
    },
    async handleClickRemoveButton() {
      if (!confirm("ยืนยันการลบคูปอง")) {
        return;
      }
      const { id } = this.$route.params;
      await baanRueJaiClient.admin.subscriptions.coupons.delete(id);

      this.$router.push({ name: "CouponListPage" });
    },
    async handleClickSubmitButton() {
      try {
        await this.updateCoupon();
        this.$router.push({ name: "CouponListPage" });
      } catch (error) {
        alert(error.response.data.message);
        console.error(error);
      }
    },
    async updateCoupon() {
      const { id } = this.$route.params;

      const params = {
        code: this.form.code,
        expiryDate: toOptionalISOString(this.form.expiryDate),
        selectedPackageIds: this.form.selectedPackages.map(({ id }) => +id),
        supportedProjectIds: this.form.supportedProjectIds,
        expiredDaysAfterTransfered: this.form.expiredDaysAfterTransfered
      };

      const response = await baanRueJaiClient.admin.subscriptions.coupons.put(
        id, params
      );

      return response.data.result;
    },
  }
};
</script>

<style lang="scss" scoped>
.btn-submit {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/coupons/pages/CouponDetailPage.vue